import React, { useState, useEffect } from 'react';
import { getSession } from '../../getSession';
import { getUserWebformListByUserId } from '../../utils/lead';

const WebForm = ({ onSubmit, onClose, initial = {}, onSelectChange }) => {
  const [webforms, setWebforms] = useState([]);
  const [selected, setSelected] = useState(initial.selected || '');

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const { userId, TokenId } = getSession();
        const payload = {
          Token: TokenId,
          Message: '',
          LoggedUserId: userId,
          MAC_Address: '',
          IP_Address: '',
          Details: { UserId: userId },
          BroadcastName: ''
        };
        const resp = await getUserWebformListByUserId(payload);
        const list = Array.isArray(resp) ? resp : [];
        // map CommonEntity: { Code: FormId, Text: FormName }
        const mapped = list.map(item => ({ value: String(item?.Code ?? item?.FormId ?? item?.Id ?? ''), label: String(item?.Text ?? item?.FormName ?? item?.Name ?? item) }));
        if (mounted) {
          setWebforms([{ value: '', label: '--Select--' }, ...mapped]);
        }
      } catch (err) {
        console.warn('load webforms error', err);
      }
    };
    load();
    return () => { mounted = false; };
  }, []);

  const handleSave = (e) => {
    e.preventDefault();
    if (!selected) {
      alert('Please select a webform');
      return;
    }
    if (onSubmit) onSubmit({ webform: selected });
  };

  return (
    <div className="w-full p-4">
      <form onSubmit={handleSave}>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Select Webform</label>
          <select
            value={selected}
            onChange={e => {
              const val = e.target.value;
              setSelected(val);
              if (onSelectChange) {
                const found = webforms.find(w => String(w.value) === String(val));
                if (found) onSelectChange(found); else onSelectChange({ value: val, label: val });
              }
            }}
            className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
          >
            {webforms.length ? (
              webforms.map((w) => (
                <option key={w.value} value={w.value}>{w.label}</option>
              ))
            ) : (
              <option value="">No webforms</option>
            )}
          </select>
        </div>

      </form>
    </div>
  );
};

export default WebForm;
